var EPK = EPK || {};

EPK.ProductCommon = EPK.ProductCommon || {};
EPK.ProductCommon = function () {};

EPK.ProductCommonParams = EPK.ProductCommonParams || {};

/**
 * <SP版共通>
 * 商品検索共通フッターの大カテゴリに紐づく商品数を取得してセットする
 */
EPK.ProductCommon.dispCategoryItemCountForCommonFooter = function (designPattern) {
	if (!EPK.ProductCommonParams.isSP) {
		return;
	}

	var displayPlaceObject = $('.product-common-footer-2');
	if (!displayPlaceObject.length) {
		return;
	}

	var data = {}

	if (EPK.ProductCommonParams.remakeC) {
		data['remake_c'] = EPK.ProductCommonParams.remakeC;
	}

	$.ajax({
		type: 'GET',
		url: '/api/product/disp_cat_item_count/common_footer',
		data: data,
		cache: false,
		dataType: 'json',
	}).done(
			function (data) {
				if (data['category_item_count_list']) {
					for (var category_master_id = 565; category_master_id <= 568; category_master_id += 1) {
						if (!$('.product-common-footer-2 .count_' + category_master_id).length) {
							return;
						}

						if (data['category_item_count_list'][category_master_id]) {
							$('.product-common-footer-2 .count_' + category_master_id + ' span').text(data['category_item_count_list'][category_master_id]);
						} else {
							$('.product-common-footer-2 .count_' + category_master_id).remove();
						}
					}
					;
				} else {
					for (var category_master_id = 565; category_master_id <= 568; category_master_id += 1) {
						if (!$('.product-common-footer-2 .count_' + category_master_id).length) {
							return;
						}

						$('.product-common-footer-2 .count_' + category_master_id).remove();
					}
				}
			}
	).fail(
			function (data) {
				for (var category_master_id = 565; category_master_id <= 568; category_master_id += 1) {
					if (!$('.product-common-footer-2 .count_' + category_master_id).length) {
						return;
					}

					$('.product-common-footer-2 .count_' + category_master_id).remove();
				}

				console.log('fail');
				console.log(data);
			}
	);

	return true;
};

/**
 * 商品毎の最低価格を取得してセットする
 */
EPK.ProductCommon.getMinPrice = function (paramDisplayPlaceText, designPattern, forceAllPrefFlag) {
	var displayPlaceObject = $('.item-min-price-' + paramDisplayPlaceText);
	if (!displayPlaceObject.length) {
		return;
	}

	var itemMasterIdList = [];
	$.each(displayPlaceObject, function (key, elm) {
		if (!$(elm).data('item_master_id')) {
			return;
		}

		itemMasterIdList[key] = $(elm).data('item_master_id');
	});
	if (!itemMasterIdList.length) {
		return;
	}

	var data = {
		'item_master_id_list': itemMasterIdList,
		'force_all_pref_flag': forceAllPrefFlag,
	}

	if (EPK.ProductCommonParams.prefCd) {
		data['pref_cd'] = EPK.ProductCommonParams.prefCd;
	}

	if (EPK.ProductCommonParams.cityId) {
		data['city_id'] = EPK.ProductCommonParams.cityId;
	}

	if (EPK.ProductCommonParams.dispP) {
		data['disp_p'] = EPK.ProductCommonParams.dispP;
	}

	if (EPK.ProductCommonParams.remakeC) {
		data['remake_c'] = EPK.ProductCommonParams.remakeC;
	}

	$.ajax({
		type: 'POST',
		url: '/api/product/disp_item_min_price',
		data: data,
		cache: false,
		dataType: 'json',
	}).done(
			function (data) {
				if (data['item_min_price_list']) {
					var itemMasterId = null;
					var itemMinPriceData = [];
					var itemMinPriceHtml = '';
					var labelUseEparkPointHtml = '';
					var unitPriceHtml = '';
					var addTagTextStart = '';
					var addTagTextEnd = '';

					$.each(displayPlaceObject, function (key, elm) {
						if (!$(elm).data('item_master_id')) {
							return;
						}

						itemMasterId = $(elm).data('item_master_id');

						if (!data['item_min_price_list'][itemMasterId]) {
							return;
						}

						itemMinPriceData = data['item_min_price_list'][itemMasterId];

						if ('pos_display_price_flag' in itemMinPriceData) {
							if (itemMinPriceData['pos_display_price_flag'] != 1) {
								return;
							}
						}

						// 同一classでもっと見るまで賄う為の対策 ↓
						// 既にclassがある場合はHTMLを付加しない
						if ($(elm).hasClass('exist-item-min-price-new')) {
							return;
						}

						// 二重にHTMLを付加しない為のスタンプ
						$(elm).addClass('exist-item-min-price-new');
						// 同一classでもっと見るまで賄う為の対策 ↑

						switch (designPattern) {
							// SP版商品検索TOP 注目の商品
							// SP版商品検索TOP 医薬品・医療機器の新着商品
							// SP版商品一覧 かぜ補助薬の新着商品
							case 1:
								itemMinPriceHtml = '<b class="exist-item-min-price-new">' + itemMinPriceData['price_text'] + '</b>' + '円(' + itemMinPriceData['tax_flag_text'] + ')～';
								$(elm).append(itemMinPriceHtml);

								if('use_epark_point' in itemMinPriceData && itemMinPriceData['use_epark_point'] > 0){
									labelUseEparkPointHtml = '<p class="epk-point-label"><img src="' + itemMinPriceData['label_image_path_use_epark_point_sp_1'] + '" alt=""></p>';
									$(elm).after(labelUseEparkPointHtml);
								}

								break;

							// PC版商品検索TOP 注目の商品
							// PC版商品一覧 かぜ補助薬のおすすめ商品
							// PC版商品一覧 かぜ補助薬の新着商品
							case 2:
								itemMinPriceHtml = itemMinPriceData['price_text'] + '<span class="exist-item-min-price-new">円(' + itemMinPriceData['tax_flag_text'] + ')～</span>';
								$(elm).append(itemMinPriceHtml);

								if('use_epark_point' in itemMinPriceData && itemMinPriceData['use_epark_point'] > 0){
									labelUseEparkPointHtml = '<p class="epk-point-label"><img src="' + itemMinPriceData['label_image_path_use_epark_point_pc_1'] + '" alt=""></p>';
									$(elm).after(labelUseEparkPointHtml);
								}

								break;

							// SP版カテゴリTOP 医薬品・医療機器の人気商品
							case 3:
								itemMinPriceHtml = '<b class="exist-item-min-price-new">' + itemMinPriceData['price_text'] + '</b>' + '円(' + itemMinPriceData['tax_flag_text'] + ')～';
								$(elm).append(itemMinPriceHtml);

								var afterHtml = '';

								if('lot' in itemMinPriceData && itemMinPriceData['lot'] > 1 && 'unit_price_data' in itemMinPriceData){
									unitPriceHtml = '<div class="perone">1' + itemMinPriceData['unit'] + 'あたり<p><span>';

									if('unit_price_decimal' in itemMinPriceData['unit_price_data'] && itemMinPriceData['unit_price_data']['unit_price_decimal'] > 0){
										unitPriceHtml = unitPriceHtml + '<b>' + itemMinPriceData['unit_price_data']['unit_price_integer_text'] + '.</b>' + itemMinPriceData['unit_price_data']['unit_price_decimal'];
									}else{
										unitPriceHtml = unitPriceHtml + '<b>' + itemMinPriceData['unit_price_data']['unit_price_text'] + '</b>';
									}

									unitPriceHtml = unitPriceHtml + '</span>円(税込)～</p></div>';

									afterHtml = afterHtml + unitPriceHtml;
								}

								if('use_epark_point' in itemMinPriceData && itemMinPriceData['use_epark_point'] > 0){
									labelUseEparkPointHtml = '<p class="epk-label"><img src="' + itemMinPriceData['label_image_path_use_epark_point_sp_1'] + '" alt=""></p>';

									afterHtml = afterHtml + labelUseEparkPointHtml;
								}

								$(elm).after(afterHtml);

								break;

							// SP版カテゴリTOP 医薬品・医療機器のおすすめ商品
							// SP版商品一覧 かぜ補助薬のおすすめ商品
							case 4:
								itemMinPriceHtml = itemMinPriceData['price_text'] + '<b class="exist-item-min-price-new">円(' + itemMinPriceData['tax_flag_text'] + ')～</b>';
								$(elm).append(itemMinPriceHtml);

								if('use_epark_point' in itemMinPriceData && itemMinPriceData['use_epark_point'] > 0){
									labelUseEparkPointHtml = '<p class="epk-label"><img src="' + itemMinPriceData['label_image_path_use_epark_point_sp_1'] + '" alt=""></p>';
									$(elm).after(labelUseEparkPointHtml);
								}

								break;

							// PC版カテゴリTOP 注目の商品
							// PC版カテゴリTOP 医薬品・医療機器のおすすめ商品
							case 5:
								itemMinPriceHtml = itemMinPriceData['price_text'] + '<span class="exist-item-min-price-new">円(' + itemMinPriceData['tax_flag_text'] + ')～</span>';
								$(elm).append(itemMinPriceHtml);

								var afterHtml = '';

								if('lot' in itemMinPriceData && itemMinPriceData['lot'] > 1 && 'unit_price_data' in itemMinPriceData){
									unitPriceHtml = '<span class="perone"><span class="ttl">1' + itemMinPriceData['unit'] + 'あたり</span>';

									if('unit_price_decimal' in itemMinPriceData['unit_price_data'] && itemMinPriceData['unit_price_data']['unit_price_decimal'] > 0){
										unitPriceHtml = unitPriceHtml + '<b>' + itemMinPriceData['unit_price_data']['unit_price_integer_text'] + '.' + itemMinPriceData['unit_price_data']['unit_price_decimal'] + '</b>';
									}else{
										unitPriceHtml = unitPriceHtml + '<b>' + itemMinPriceData['unit_price_data']['unit_price_text'] + '</b>';
									}

									unitPriceHtml = unitPriceHtml + '円(税込)～</span>';

									afterHtml = afterHtml + unitPriceHtml;
								}

								if('use_epark_point' in itemMinPriceData && itemMinPriceData['use_epark_point'] > 0){
									labelUseEparkPointHtml = '<p class="epk-point-label"><img src="' + itemMinPriceData['label_image_path_use_epark_point_pc_1'] + '" class="epk-point-label-m" alt=""></p>';

									afterHtml = afterHtml + labelUseEparkPointHtml;
								}

								$(elm).after(afterHtml);

								break;

							// SP版商品一覧 かぜ補助薬の商品一覧・もっと見る
							case 6:
								itemMinPriceHtml = '<b class="exist-item-min-price-new">' + itemMinPriceData['price_text'] + '</b>' + '円(' + itemMinPriceData['tax_flag_text'] + ')～';
								$(elm).append(itemMinPriceHtml);

								var afterHtml = '';

								if('lot' in itemMinPriceData && itemMinPriceData['lot'] > 1 && 'unit_price_data' in itemMinPriceData){
									unitPriceHtml = '<div class="perone">1' + itemMinPriceData['unit'] + 'あたり<p><span>';

									if('unit_price_decimal' in itemMinPriceData['unit_price_data'] && itemMinPriceData['unit_price_data']['unit_price_decimal'] > 0){
										unitPriceHtml = unitPriceHtml + '<b>' + itemMinPriceData['unit_price_data']['unit_price_integer_text'] + '.</b>' + itemMinPriceData['unit_price_data']['unit_price_decimal'];
									}else{
										unitPriceHtml = unitPriceHtml + '<b>' + itemMinPriceData['unit_price_data']['unit_price_text'] + '</b>';
									}

									unitPriceHtml = unitPriceHtml + '</span>円(税込)～</p></div>';

									afterHtml = afterHtml + unitPriceHtml;
								}

								if('use_epark_point' in itemMinPriceData && itemMinPriceData['use_epark_point'] > 0){
									labelUseEparkPointHtml = '<p class="epk-point-label"><img src="' + itemMinPriceData['label_image_path_use_epark_point_sp_1'] + '" alt=""></p>';

									afterHtml = afterHtml + labelUseEparkPointHtml;
								}

								$(elm).after(afterHtml);

								break;

							// PC版商品一覧 かぜ補助薬の商品一覧
							case 7:
								itemMinPriceHtml = itemMinPriceData['price_text'] + '<span class="exist-item-min-price-new">円(' + itemMinPriceData['tax_flag_text'] + ')～</span>';
								$(elm).append(itemMinPriceHtml);

								var afterHtml = '';

								if('lot' in itemMinPriceData && itemMinPriceData['lot'] > 1 && 'unit_price_data' in itemMinPriceData){
									unitPriceHtml = '<div class="perone">1' + itemMinPriceData['unit'] + 'あたり';

									if('unit_price_decimal' in itemMinPriceData['unit_price_data'] && itemMinPriceData['unit_price_data']['unit_price_decimal'] > 0){
										unitPriceHtml = unitPriceHtml + '<span><b>' + itemMinPriceData['unit_price_data']['unit_price_integer_text'] + '.' + itemMinPriceData['unit_price_data']['unit_price_decimal'] + '</b>';
									}else{
										unitPriceHtml = unitPriceHtml + '<span><b>' + itemMinPriceData['unit_price_data']['unit_price_text'] + '</b>';
									}

									unitPriceHtml = unitPriceHtml + '円(税込)～</span></div>';

									afterHtml = afterHtml + unitPriceHtml;
								}

								if('use_epark_point' in itemMinPriceData && itemMinPriceData['use_epark_point'] > 0){
									labelUseEparkPointHtml = '<p class="epk-point-label"><img src="' + itemMinPriceData['label_image_path_use_epark_point_pc_1'] + '" class="epk-point-label-m" alt=""></p>';

									afterHtml = afterHtml + labelUseEparkPointHtml;
								}

								$(elm).after(afterHtml);

								break;

							// SP版商品詳細 かぜ補助薬カテゴリーのおすすめ商品
							case 8:
								itemMinPriceHtml = ' <span class="price"><strong>' + itemMinPriceData['price_text'] + '</strong>円(' + itemMinPriceData['tax_flag_text'] + ')～</span>';
								$(elm).append(itemMinPriceHtml);

								if('use_epark_point' in itemMinPriceData && itemMinPriceData['use_epark_point'] > 0){
									labelUseEparkPointHtml = '<p class="epk-point-label"><img src="' + itemMinPriceData['label_image_path_use_epark_point_sp_1'] + '" alt=""></p>';
									$(elm).after(labelUseEparkPointHtml);
								}

								break;

							// PC版商品詳細 かぜ補助薬カテゴリーのおすすめ商品
							case 9:
								itemMinPriceHtml = ' <span class="price"><b>' + itemMinPriceData['price_text'] + '</b>円(' + itemMinPriceData['tax_flag_text'] + ')～</span>';
								$(elm).append(itemMinPriceHtml);

								if('use_epark_point' in itemMinPriceData && itemMinPriceData['use_epark_point'] > 0){
									labelUseEparkPointHtml = '<p class="epk-point-label"><img src="' + itemMinPriceData['label_image_path_use_epark_point_pc_1'] + '" alt=""></p>';
									$(elm).after(labelUseEparkPointHtml);
								}

								break;

							// PC版商品検索TOP 医薬品・医療機器の新着商品
							// PC版カテゴリTOP 医薬品・医療機器の新着商品
							case 10:
								itemMinPriceHtml = itemMinPriceData['price_text'] + '<span class="exist-item-min-price-new">円(' + itemMinPriceData['tax_flag_text'] + ')～</span>';
								$(elm).append(itemMinPriceHtml);

								if('use_epark_point' in itemMinPriceData && itemMinPriceData['use_epark_point'] > 0){
									labelUseEparkPointHtml = '<p class="epk-point-label"><img src="' + itemMinPriceData['label_image_path_use_epark_point_pc_1'] + '" alt=""></p>';
									$(elm).parents('.p-product-new-arrival--text').after(labelUseEparkPointHtml);
								}

								break;

							default:
								break;
						}
					});
				}
			}
	).fail(
			function (data) {
				console.log('fail');
				console.log(data);
			}
	);

	return true;
};

/**
 * 商品毎の取扱店舗数を取得してセットする
 */
EPK.ProductCommon.getItemShopCount = function (paramDisplayPlaceText, designPattern) {
	var displayPlaceObject = $('.item-shop-count-' + paramDisplayPlaceText);
	if (!displayPlaceObject.length) {
		return;
	}

	var itemMasterIdList = [];
	$.each(displayPlaceObject, function (key, elm) {
		if (!$(elm).data('item_master_id')) {
			return;
		}

		itemMasterIdList[key] = $(elm).data('item_master_id');
	});
	if (!itemMasterIdList.length) {
		return;
	}

	var data = {
		'item_master_id_list': itemMasterIdList,
	}

	if (EPK.ProductCommonParams.prefCd) {
		data['pref_cd'] = EPK.ProductCommonParams.prefCd;
	}

	if (EPK.ProductCommonParams.cityId) {
		data['city_id'] = EPK.ProductCommonParams.cityId;
	}

	if (EPK.ProductCommonParams.remakeC) {
		data['remake_c'] = EPK.ProductCommonParams.remakeC;
	}

	$.ajax({
		type: 'POST',
		url: '/api/product/disp_item_shop_count',
		data: data,
		cache: false,
		dataType: 'json',
	}).done(
			function (data) {
				if (data['item_shop_count_list']) {
					var itemMasterId = null;
					var itemShopCountData = [];
					var itemMinPriceHtml = '';
					var addTagTextStart = '';
					var addTagTextEnd = '';

					$.each(displayPlaceObject, function (key, elm) {
						if (!$(elm).data('item_master_id')) {
							return;
						}

						itemMasterId = $(elm).data('item_master_id');

						if (!data['item_shop_count_list'][itemMasterId]) {
							return;
						}

						itemShopCountData = data['item_shop_count_list'][itemMasterId];

						switch (designPattern) {
							case 1:
								itemShopCountHtml = '取り扱い店舗：' + itemShopCountData['count'] + '件';
								break;

							default:
								break;
						}


						$(elm).append(itemShopCountHtml);
					});
				}
			}
	).fail(
			function (data) {
				console.log('fail');
				console.log(data);
			}
	);

	return true;
};

/**
 * メーカー毎の商品数を取得してセットする
 */
EPK.ProductCommon.getMakerItemCount = function (designPattern, forceAllPrefFlag) {
	var displayPlaceObject = $('.maker-item-count');
	if (!displayPlaceObject.length) {
		return;
	}

	var makerMasterIdList = [];
	$.each(displayPlaceObject, function (key, elm) {
		if (!$(elm).data('maker_master_id')) {
			return;
		}

		makerMasterIdList[key] = $(elm).data('maker_master_id');
	});
	if (!makerMasterIdList.length) {
		return;
	}

	var data = {
		'maker_master_id_list': makerMasterIdList,
		'force_all_pref_flag': forceAllPrefFlag,
	}

	if (EPK.ProductCommonParams.remakeC) {
		data['remake_c'] = EPK.ProductCommonParams.remakeC;
	}

	if (EPK.ProductCommonParams.categoryPath) {
		 data['category_path'] = EPK.ProductCommonParams.categoryPath;
	}

	if (EPK.ProductCommonParams.categoryId2) {
		data['category_id2'] = EPK.ProductCommonParams.categoryId2;
	}

	$.ajax({
		type: 'POST',
		url: '/api/product/disp_maker_item_count',
		data: data,
		cache: false,
		dataType: 'json',
	}).done(
			function (data) {
				if (data['maker_item_count_list']) {
					var makerMasterId = null;
					var makerItemCountData = [];
					var makerItemCountHtml = '';
					var addTagTextStart = '';
					var addTagTextEnd = '';

					$.each(displayPlaceObject, function (key, elm) {
						if (!$(elm).data('maker_master_id')) {
							return;
						}

						makerMasterId = $(elm).data('maker_master_id');

						if (!data['maker_item_count_list'][makerMasterId]) {
							return;
						}

						makerItemCountData = data['maker_item_count_list'][makerMasterId];

						switch (designPattern) {
							case 1:
								makerItemCountHtml = '（' + makerItemCountData['count'] + '）';
								break;

							default:
								break;
						}

						$(elm).append(makerItemCountHtml);
					});
				}
			}
	).fail(
			function (data) {
				console.log('fail');
				console.log(data);
			}
	);

	return true;
};

/**
 * 新着商品をもっと見るボタンクリック
 */
EPK.ProductCommon.showMoreNewLists = function () {

	var objSection = $('.itemdetail-new-list');
	var more = $('.new-list-more');
	var categoryId = more.children('a').attr('target-category-id');
	var page = more.children('a').attr('target-page');
	var limit = more.children('a').attr('target-limit');

	$.ajax({
		type: 'GET',
		url: '/api/product/new_item_list',
		cache: false,
		dataType: "html",
		data: {
			category_id: categoryId,
			page: page,
			limit: limit,
		}
	}).done(
			function (data) {
				if (data) {
					more.children('a').attr({'target-page': parseInt(page) + 1});
					objSection.append(data);

					EPK.ProductCommon.getMinPrice('new', 2, 1);
				}
			}
	).fail(
			function (data) {
			}
	);
};

/**
 * エリア変更をクリック
 */
EPK.ProductCommon.popupAreaClick = function () {

	var pref = $('input:radio[name="radio-prefecture"]:checked').val();

	if (pref) {
		$('input:radio[name="radio-prefecture"]').prop('checked', false);
		$('.bottom-fixed-menu-pref .filtering').addClass('disabled');
		$('.bottom-fixed-menu-pref .search').addClass('disabled');
	}
};

/**
 * エリアから商品を探すカテゴリをクリック
 */
EPK.ProductCommon.popupCategoryClick = function (category) {
	$("#modal-area-category").val(category);
	$("#modal-area-category-id").val('');
};

/**
 * エリア変更（都道府県）エリアをクリック
 */
EPK.ProductCommon.popupAreaPrefClick = function () {

	var pref = $('input:radio[name="radio-prefecture"]:checked').val();
	if (pref == 'all') {
		$('.bottom-fixed-menu-pref .filtering').addClass('disabled');
	} else {
		$('.bottom-fixed-menu-pref .filtering').removeClass('disabled');
	}
	$('.bottom-fixed-menu-pref .search').removeClass('disabled');
};

/**
 * エリア変更（都道府県）検索をクリック
 */
EPK.ProductCommon.popupAreaPrefSeartch = function () {

	var pref = $('input:radio[name="radio-prefecture"]:checked').val();
	var categoryPath = $("#modal-area-category").val();
	var categoryId = $("#modal-area-category-id").val();

	var target_url = '';
	if (pref == 'all') {
		target_url = '/product/' + categoryPath;
		if (categoryPath && categoryId) {
			target_url = '/product/' + categoryPath + '/ci' + categoryId + '/';
		}
	} else if (categoryId) {
		target_url = '/product/' + categoryPath + '/ci' + categoryId + '/' + pref + '/list';
	} else {
		target_url = '/product/' + categoryPath + '/' + pref + '/list';
	}

	window.location.href = target_url;
};

/**
 * エリア変更（都道府県）SP初期表示
 */
EPK.ProductCommon.showSPModalsPrefList = function () {

	var objSection = $('.popup-scroll-inner-pref');
	var categoryPath = $("#modal-area-category").val();
	var categoryId = $("#modal-area-category-id").val();

	var data = {
		category_path: categoryPath,
		category_id2: categoryId,
	}

	if (EPK.ProductCommonParams.remakeC) {
		data['remake_c'] = EPK.ProductCommonParams.remakeC;
	}

	$.ajax({
		type: 'GET',
		url: '/api/product/get_pref',
		data: data,
		cache: false,
		dataType: "html"
	}).done(
			function (data) {
				if (data) {
					objSection.empty();
					objSection.append(data);
					$('.bottom-fixed-menu-city .search').addClass('disabled');

					// エリア変更（都道府県）エリアをクリック
					$('.popup-scroll-inner-pref input').on('click', function () {
						EPK.ProductCommon.popupAreaPrefClick();
					});

					// エリア変更（都道府県）検索をクリック
					$('.bottom-fixed-menu-pref .search').on('click', function () {
						EPK.ProductCommon.popupAreaPrefSeartch();
					});

					// エリア変更（都道府県）さらに絞り込むをクリック
					$('#modal-product-search-choise-area-city-btn').on('click', function () {
						EPK.ProductCommon.showSPModalsAreaList();
					});
				}
			}
	).fail(
			function (data) {
			}
	);
};

/**
 * エリア変更（都道府県）SPさらに絞り込むをクリック
 */
EPK.ProductCommon.showSPModalsAreaList = function () {

	EPK.ProductCommon.modalBgScrollControll();

	var objSection = $('.popup-scroll-inner-area');
	var pref = $('input:radio[name="radio-prefecture"]:checked').val();
	if (!pref) {
		pref = EPK.ProductCommonParams.prefCd;
	}
	var categoryPath = $("#modal-area-category").val();
	var categoryId = $("#modal-area-category-id").val();

	var data = {
		pref_furi: pref,
		category_path: categoryPath,
		category_id2: categoryId,
	}

	if (EPK.ProductCommonParams.remakeC) {
		data['remake_c'] = EPK.ProductCommonParams.remakeC;
	}

	$.ajax({
		type: 'GET',
		url: '/api/product/get_city',
		data: data,
		cache: false,
		dataType: "html"
	}).done(
			function (data) {
				if (data) {
					objSection.empty();
					objSection.append(data);
					$("#modal-area-pref").val(pref);
					$('.bottom-fixed-menu-city .search').addClass('disabled');

					// エリア変更（市区町村）エリアをクリック
					$('.popup-scroll-inner-area input').on('click', function () {
						EPK.ProductCommon.popupAreaCityClick();
					});

					// エリア変更（市区町村）検索をクリック
					$('.bottom-fixed-menu-city .search').on('click', function () {
						EPK.ProductCommon.popupAreaCitySeartch();
					});
				}
			}
	).fail(
			function (data) {
			}
	);
};

/**
 * エリア変更（都道府県）PC初期表示
 */
EPK.ProductCommon.showPCModalsPrefList = function () {

	var objSection = $('.modal-checkbox-pref');
	var categoryPath = $("#modal-area-category").val();
	var categoryId = $("#modal-area-category-id").val();

	var data = {
		category_path: categoryPath,
		category_id2: categoryId,
	}

	if (EPK.ProductCommonParams.remakeC) {
		data['remake_c'] = EPK.ProductCommonParams.remakeC;
	}

	$.ajax({
		type: 'GET',
		url: '/api/product/get_pref',
		data: data,
		cache: false,
		dataType: "html"
	}).done(
			function (data) {
				if (data) {
					objSection.empty();
					objSection.append(data);
					$('.bottom-fixed-menu-city .search').addClass('disabled');

					// エリア変更（都道府県）エリアをクリック
					$('.modal-checkbox-pref input').on('click', function () {
						EPK.ProductCommon.popupAreaPrefClick();
					});

					// エリア変更（都道府県）検索をクリック
					$('.bottom-fixed-menu-pref .search').on('click', function () {
						EPK.ProductCommon.popupAreaPrefSeartch();
					});

					// エリア変更（都道府県）さらに絞り込むをクリック
					$('#modal-product-search-choise-area-city-btn').on('click', function () {
						EPK.ProductCommon.showPCModalsAreaList();
					});
				}
			}
	).fail(
			function (data) {
			}
	);
};

/**
 * エリア変更（都道府県）PCさらに絞り込むをクリック
 */
EPK.ProductCommon.showPCModalsAreaList = function () {

	var objSection = $('.modal-location-city');
	var pref = $('input:radio[name="radio-prefecture"]:checked').val();
	if (!pref) {
		pref = EPK.ProductCommonParams.prefCd;
	}
	var categoryPath = $("#modal-area-category").val();
	var categoryId = $("#modal-area-category-id").val();

	var data = {
		pref_furi: pref,
		category_path: categoryPath,
		category_id2: categoryId,
	}

	if (EPK.ProductCommonParams.remakeC) {
		data['remake_c'] = EPK.ProductCommonParams.remakeC;
	}

	$.ajax({
		type: 'GET',
		url: '/api/product/get_city',
		data: data,
		cache: false,
		dataType: "html"
	}).done(
			function (data) {
				if (data) {
					objSection.empty();
					objSection.append(data);
					$("#modal-area-pref").val(pref);
					$('.bottom-fixed-menu-city .search').addClass('disabled');

					// エリア変更（市区町村）エリアをクリック
					$('.modal-checkbox-city input').on('click', function () {
						EPK.ProductCommon.popupAreaCityClick();
					});

					// エリア変更（市区町村）検索をクリック
					$('.bottom-fixed-menu-city .search').on('click', function () {
						EPK.ProductCommon.popupAreaCitySeartch();
					});
				}
			}
	).fail(
			function (data) {
			}
	);
};

/**
 * エリア変更（市区町村）エリアをクリック
 */
EPK.ProductCommon.popupAreaCityClick = function () {

	$('.bottom-fixed-menu-city .search').removeClass('disabled');
};

/**
 * エリア変更（市区町村）検索をクリック
 */
EPK.ProductCommon.popupAreaCitySeartch = function () {

	var city = $('input:radio[name="radio-city"]:checked').val();
	var pref = $("#modal-area-pref").val();
	var categoryPath = $("#modal-area-category").val();
	var categoryId = $("#modal-area-category-id").val();

	var target_url = '';
	if (categoryId) {
		target_url = '/product/' + categoryPath + '/ci' + categoryId + '/' + pref + '/list/' + city;
	} else {
		target_url = '/product/' + categoryPath + '/' + pref + '/list/' + city;
	}

	window.location.href = target_url;
};

/**
 * SP版モーダル表示中
 * bodyスクロール制御
 */
EPK.ProductCommon.modalBgScrollControll = function (floatBtn) {

	//モーダル表示中bodyscroll制御
	var scrollPosition = window.pageYOffset;
	var closeBtn = document.getElementsByClassName('popup-close-btn');
	var floatBtn = document.querySelectorAll('div.mfp-wrap .bottom-fixed-menu');
	//フロートボタンがあるモーダルのみpaddingの対応を入れる。
	if (floatBtn.length > 0) {

		var modal,scrollElem,windowHeight,modalStyle,modalPaddingBottom,clientRect;
		modal = document.getElementById('modal-product-search-choise-area-pref');
		scrollElem = document.querySelectorAll('div.mfp-wrap ul.popup-scroll-inner');
	
		if (modal && scrollElem.length > 0) {
			modalStyle = getComputedStyle(scrollElem[0],null);
			floatBtnStyle = getComputedStyle(floatBtn[0],null);
			modalPaddingBottom = Number(modalStyle.paddingBottom.replace(/px/g , ""));
			//cssのpaddingと比較していかっだった場合にpaddingをつける
			if (modalPaddingBottom <= 120) {
				floatBtnHeight = Number(floatBtnStyle.height.replace(/px/g , ""));
				scrollElem[0].style.paddingBottom = (modalPaddingBottom + floatBtnHeight) + 'px';
			}

		}
	
	}
	document.body.style.position = 'fixed';
	if (closeBtn.length > 0) {
		[].forEach.call(closeBtn,function(elem) {
			
			elem.addEventListener('click',function() {
				scrollElem = document.querySelectorAll('ul.popup-scroll-inner');
				if (scrollElem.length > 0) {
					for (var i = 0; i < scrollElem.length; i++) {
						scrollElem[i].style.paddingBottom = '';
					}
				}
				document.body.style.position = '';
				window.scrollTo(0,scrollPosition);
			},false);
		})
	}
}

/**
 * EPARKポイント取得/画面へのセット
 * ※PharmacyDetailからコピー
 */
EPK.ProductCommon.setEparkPoint = function() {
	// SP版のみ実行
	if(!EPK.common.isMobile){
		return true;
	}

	// ログイン時のみ実施
	if (!EPK.common.isLogin) {
		return true;
	}

	$.ajax({
		type: 'POST',
		url: '/api/detail/get_epark_point',
		data: {
		},
		cache: false,
		dataType: 'json',
		timeout: 100000
	})
	.done(function(data) {
		if(data['result'] == 'success'){
			var user_epark_point = EPK.ProductCommon.numSeparate(data['total_pt']);
			$('#disp_area_epark_point').append(user_epark_point);
		}else if(data['result'] == 'not_login'){
			return false;
		}else if(data['result'] == 'api_error'){
			return false;
		}
		return true;
	}).fail(function(data){
		console.log('failed');
		console.log(data);
		return false;
	});
};

/**
 * 数値のカンマ編集
 * ※PharmacyDetailからコピー
 */
EPK.ProductCommon.numSeparate = function(num) {
	num = String(num);

	var strMinus = '';
	if (num.indexOf('-') > -1) {
		strMinus = '-';
	}

	num = num.replace(/-/g, '');
	var len = num.length;

	if (len > 3) {
		// 前半を引数に再帰呼び出し + 後半3桁
		return strMinus + this.numSeparate(num.substring(0, len - 3)) + ',' + num.substring(len - 3);
	} else {
		return strMinus + num;
	}
}

$(function () {

	/**
	 * SP版のみ
	 */
	if (EPK.ProductCommonParams.isSP) {
		if ($('.product-common-footer-2').length) {
			EPK.ProductCommon.dispCategoryItemCountForCommonFooter(0);
		}

		// 新着商品をもっと見るボタンクリック
		$('.new-list-more a').on('click', function (event) {
			EPK.ProductCommon.showMoreNewLists(event);
		});

		// エリアから商品を探すカテゴリをクリック
		$('.product-modal-area-category').on('click', function () {
			var category = $(this).attr('target-category');
			EPK.ProductCommon.popupCategoryClick(category);

			//モーダルのクラスの付け替え
			var mfpWrap = document.getElementsByClassName('mfp-wrap');
			if (mfpWrap.length > 0) {

				if (mfpWrap[0].classList.contains('item-search-modal-wrap')) {
					mfpWrap[0].classList.remove('item-search-modal-wrap');
					EPK.ProductCommon.modalBgScrollControll();
				}
				
			}
		});

		// エリア変更をクリック
		$('.modal-product-search-choise-area-btn').on('click', function (e) {
			EPK.ProductCommon.popupAreaClick();
			EPK.ProductCommon.showSPModalsPrefList();
			//モーダル表示中bodyscroll制御
			if (e.currentTarget.classList.contains('product-modal-area-category')) {
				return;
			}
			var targetModal = document.querySelectorAll('.mfp-wrap div#modal-product-search-choise-area-pref');
			if (targetModal.length > 0) {
				EPK.ProductCommon.modalBgScrollControll();
			}
		});

		//カテゴリを変更する
		$('#modal-product-search-choise-category-btn').on('click',function () {
			EPK.ProductCommon.modalBgScrollControll();
		});

		//モーダルの閉じる挙動修正の為、classを追加
		var modalBtn = document.getElementsByClassName('modal-overlay-events');
		if (modalBtn.length == 0) {
			return;
		}

		// エリア変更（リスト）さらに絞り込むをクリック
		$('#modal-product-search-choise-area-city-list-btn').on('click', function () {
			EPK.ProductCommon.showSPModalsAreaList();

			//モーダルのクラスの付け替え
			var mfpWrap = document.getElementsByClassName('mfp-wrap');
			if (mfpWrap.length > 0) {

				if (mfpWrap[0].classList.contains('item-search-modal-wrap')) {
					mfpWrap[0].classList.remove('item-search-modal-wrap');
					EPK.ProductCommon.modalBgScrollControll();
				}
				
			}
		});

		if (modalBtn.length > 0) {
			Array.prototype.forEach.call(modalBtn, function (elem) {
				elem.addEventListener('click',function (e) {
					if (e.target.id == 'modal-product-search-choise-area-pref2-btn' ||
						e.target.id == 'modal-product-search-choise-area-city-list-btn') {
						//直接エリアから探すのモーダルを表示する場合は追加しない
						return;
					}
					var mfpWrap = document.getElementsByClassName('mfp-wrap');
					if (mfpWrap.length > 0) {
						//エリアを絞り込むの場合
						mfpWrap[0].classList.add('item-search-modal-wrap');
					}
				},false);
			});
		}

		// #14892 ポイント吹き出し
		var pointBaloonBox = document.getElementsByClassName('point-baloon-box');
		if (pointBaloonBox.length > 0) {
			$('#point-baloon-box .baloon-close').on('click', function(){
				$('#point-baloon-box ').addClass('is-none');
			});
			EPK.ProductCommon.setEparkPoint();
		}

	} else {
		/**
		 * PC版のみ
		 */

		//おすすめスライダー
		//5枚以下　ループさせない、ボタン表示させない。
		//6枚以上　ループさせる、ボタン表示させる。
		var productSlider = document.getElementsByClassName('product-slider--wrap');
		if (productSlider.length > 0) {
			var sliderContents = document.querySelectorAll('div.product-slider--wrap .swiper-slide');
			if (sliderContents.length <= 5) {
				$('.product-slider--wrap').swiper({
					slidesPerView: 'auto',
					nextButton: '.slider-fwd',
					prevButton: '.slider-rev',
					pagination: '.slider-count',
					paginationType: 'fraction',
					watchOverflow:true
				});
			} else {
				$('.product-slider--wrap').swiper({
					loop: true,
					slidesPerView: 'auto',
					nextButton: '.slider-fwd',
					prevButton: '.slider-rev',
					pagination: '.slider-count',
					paginationType: 'fraction',
				});
			}
		}

		//カテゴリ一覧
		//18枚以下　ループさせない、ボタン表示させない。
		//19枚以上　ループさせない、ボタン表示させる。
		var productCategorySlider = document.getElementsByClassName('product-category-slider--wrap');
		if (productCategorySlider.length > 0) {
			var sliderCategoryContents = document.querySelectorAll('div.product-category-slider--wrap .swiper-slide');
			if (sliderCategoryContents.length <= 18) {
				$('.product-category-slider--wrap').swiper({
					slidesPerView: 'auto',
					nextButton: '.slider-fwd',
					prevButton: '.slider-rev',
					pagination: '.slider-count',
					paginationType: 'fraction',
					watchOverflow:true
				});
			} else {
				$('.product-category-slider--wrap').swiper({
					slidesPerView: 'auto',
					nextButton: '.slider-fwd',
					prevButton: '.slider-rev',
					pagination: '.slider-count',
					paginationType: 'fraction',
				});
			}
		}


		// エリアから商品を探すカテゴリをクリック
		$('.product-modal-area-category').on('click', function () {
			var category = $(this).attr('target-category');
			EPK.ProductCommon.popupCategoryClick(category);

			//モーダルのクラスの付け替え
			var mfpWrap = document.getElementsByClassName('mfp-wrap');
			if (mfpWrap.length > 0) {

				if (mfpWrap[0].classList.contains('modal-area-wrap')) {
					mfpWrap[0].classList.remove('modal-area-wrap');
					mfpWrap[0].classList.add('modal-location-wrap');
				}
				
			}
		});
		// 変更ボタンクリック時のクラス追加
		$('#modal-product-search-item-area-pref-btn').on('click',function () {
			//モーダルのクラスの付け替え
			var mfpWrap = document.getElementsByClassName('mfp-wrap');
			if (mfpWrap.length > 0) {

				if (!(mfpWrap[0].classList.contains('modal-location-wrap'))) {
					mfpWrap[0].classList.add('modal-location-wrap');
				}
				
			}
		})

		// エリア変更をクリック
		$('.modal-product-search-choise-area-btn').on('click', function () {
			EPK.ProductCommon.popupAreaClick();
			EPK.ProductCommon.showPCModalsPrefList();
		});

		// エリア変更（リスト）さらに絞り込むをクリック
		$('#modal-product-search-choise-area-city-list-btn').on('click', function () {
			EPK.ProductCommon.showPCModalsAreaList();
			//モーダルのクラスの付け替え
			var mfpWrap = document.getElementsByClassName('mfp-wrap');
			if (mfpWrap.length > 0) {
				if (mfpWrap[0].classList.contains('modal-area-wrap')) {
					mfpWrap[0].classList.remove('modal-area-wrap');
					mfpWrap[0].classList.add('modal-location-wrap');
				}
				
			}
		});

		//モーダルの閉じる挙動修正の為、classを追加
		var modalBtn = document.getElementsByClassName('modal-overlay-events');
		if (modalBtn.length == 0) {
			return;
		}
		if (modalBtn.length > 0) {
			Array.prototype.forEach.call(modalBtn, function (elem) {
				elem.addEventListener('click',function () {
					var mfpWrap = document.getElementsByClassName('mfp-wrap');
					if (mfpWrap.length > 0) {
						//エリアを絞り込むの場合
						if (elem.id == 'modal-product-search-choise-area-pref-btn' ||
							elem.id == 'modal-product-search-choise-area-city-list-btn') {
							mfpWrap[0].classList.add('modal-location-wrap');
						} else {
							//エリアから探す・メーカーから探す
							mfpWrap[0].classList.add('modal-area-wrap');
						}
					}
				},false);
			});
		}
	}
});

